import { makeStyles,fade } from '@material-ui/core/styles';
const drawerWidth = 0;

export default makeStyles((theme) => ({
    appBar: {
        boxShadow: 'none',
        borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
        marginBottom:'1rem',

        [theme.breakpoints.up('sm')]: {
          width: `calc(100% - ${drawerWidth}px)`,
          marginLeft: drawerWidth,
        },
      },
      title: {
        flexGrow: 0.4,
        alignItems: 'center',
        display: 'flex',
        textDecoration: 'none',
      },
      image: {
        marginRight: '10px',
      },
      menuButton: {
        marginRight: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
          display: 'none',
        },
      },
      grow: {
        flexGrow: 1,
        display:'flex',
        flexDirection:'row',
        [theme.breakpoints.down('sm')]: {
            display:'none',

        },
        
      },
      link:{
          marginRight:theme.spacing(2),

      },

      order:{
          flexGrow:1,
          justifyContent:'flex-end',
          display:'flex',


      },
      search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        '&:hover': {
          backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        marginRight: theme.spacing(2),
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
          width: 'auto',
        },
      },
      orderBtn:{
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.25),
          },
      },
      searchIcon: {
        padding: theme.spacing(0, 2),
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      inputRoot: {
        color: 'inherit',
      },
      inputInput: {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
          width: '20ch',
        },
      },

    //   Home styling below
        about:{
            marginTop:'1000px',
            paddingTop:'70px',

        },
        contact:{
            marginTop:'1000px',    
        },
        carousel:{
            height:'50vh',
            // marginTop:'100px',
        }

}));